// src/store/slices/authSlice.js
import { createSlice } from "@reduxjs/toolkit";

// Try to load { accessToken, refreshToken, user } from localStorage under key "user"
const saved = JSON.parse(localStorage.getItem("user"));
const initialState = saved || {
  accessToken: null,
  refreshToken: null,
  user: null,
  permissions: [],
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    /**
     * payload: { accessToken: string, refreshToken: string, user: object }
     */
    setUser(state, action) {
      const { accessToken, refreshToken, user } = action.payload;
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
      state.user = user;
      state.permissions = [];
      localStorage.setItem(
        "user",
        JSON.stringify({ accessToken, refreshToken, user, permissions: [] })
      );
    },
    setPermissions(state, action) {
      state.permissions = action.payload;
      const s = JSON.parse(localStorage.getItem("user"));
      if (s) {
        s.permissions = action.payload;
        localStorage.setItem("user", JSON.stringify(s));
      }
    },
    refreshTokenAction(state, action) {
      const { accessToken, refreshToken } = action.payload;
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
      // Update localStorage with new tokens
      const saved = JSON.parse(localStorage.getItem("user"));
      if (saved) {
        saved.accessToken = accessToken;
        saved.refreshToken = refreshToken;
        localStorage.setItem("user", JSON.stringify(saved));
      }
    },
    clearUser(state) {
      state.accessToken = null;
      state.refreshToken = null;
      state.user = null;
      state.permissions = [];
      localStorage.removeItem("user");
    },
  },
});

export const { setUser, setPermissions, refreshTokenAction, clearUser } = authSlice.actions;
export default authSlice.reducer;
